import React from 'react';
import { domToReact } from 'html-react-parser';
import { Headline2 } from '@cdm/quickenloans-library/lib';
import SpotlightGrid from '../../../../../components/Molecules/SpotlightGrid';
import { spotlightGridClass, innerBlocksClass, defaults } from './Constants';
import { parserPropTypes, parserPropTypesDefaults } from '../Constants';

const toSpotlightGrid = (parserData) =>
{
    const { allPosts, parserOptions: { replaceFn } } = parserData;
    const Wrapper = ({
        name = parserPropTypesDefaults.name, 
        type = parserPropTypesDefaults.type, 
        attribs = parserPropTypesDefaults.attribs, 
        children = parserPropTypesDefaults.children 
    }) =>
    {
        if ( type !== 'tag' ) return null;
        if (!name || name !== 'section') return null;
        if (!attribs?.class || !attribs?.class.includes(spotlightGridClass) ) return null;
        const cardCount = parseInt(attribs['data-card-count'] || defaults.cardCount, 10);
        const titleElement = children?.find((child) => child.type === 'tag' && child.name === 'h2') || null;
        const underGrid = children?.find((child) => child.type === 'tag' && child.name === 'div' && child.attribs?.class.includes(innerBlocksClass)) || null;
        const titleComponent = <Headline2>{titleElement ? domToReact(titleElement.children, replaceFn()) : defaults.title}</Headline2>;
        const underGridComponent = underGrid ? domToReact([underGrid], replaceFn()) : null;

        return (
            <SpotlightGrid cardCount={cardCount} title={titleComponent} underGrid={underGridComponent} posts={allPosts} />
        )
    }
    Wrapper.propTypes = parserPropTypes;
    return Wrapper;

}
export default toSpotlightGrid;
